import helperModule from '../helper.module';

class StringHelper {
    format(string, array) {
        for (var index in array) {
            var re = new RegExp(`(?:^|){([^{}]*)${index}(?:}(?!}))`, 'g');
            string = string.replace(re, array[index]);
        }
        return string;
    }

    unescape(str) {
        var el = document.createElement('textarea');
        el.innerHTML = str;
        return el.value;
    }
}

export default helperModule.service('stringHelper', StringHelper);



// WEBPACK FOOTER //
// ./modules/helper/stringHelper/stringHelper.service.js